import WebFont from 'webfontloader';

export const loadFonts = (body, categoryBar, subtitle, title) => {
  WebFont.load({
    google: {
      families: [`${body}:400,600`, `${categoryBar}:400,600`, `${subtitle}:400,600`, `${title}:600`]
    }
  });
};
